export const queryKeys = {
  user: 'user',
  lobby: 'lobby',
  token: 'token',
}
